import { __module as r } from "./ghl-ui.es1626.js";
(function(e) {
  function u(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  e.exports = u, e.exports.__esModule = !0, e.exports.default = e.exports;
})(r);
var p = r.exports;
export {
  p as i
};
